import { CheckIcon, CloseIcon } from "fe-shared/src/components/Icons";
import { InventoryAdjustmentStatusCode } from "../../../types/inventoryAdjustments";

import styles from "../InventoryAdjustmentsDetails.module.scss";
import { ActionConfig, InventoryAdjustmentAction } from "./types";

export const EditableStatusCode: InventoryAdjustmentStatusCode[] = [
  InventoryAdjustmentStatusCode.InReview,
  InventoryAdjustmentStatusCode.Reviewed,
];

const InvalidateActionVisibleStatusMap: InventoryAdjustmentStatusCode[] = [
  InventoryAdjustmentStatusCode.InReview,
  InventoryAdjustmentStatusCode.Reviewed,
];

const ApproveActionVisibleStatusMap: InventoryAdjustmentStatusCode[] = [
  InventoryAdjustmentStatusCode.InReview,
];

const SignOfActionVisibleStatusMap: InventoryAdjustmentStatusCode[] = [
  InventoryAdjustmentStatusCode.Reviewed,
];

export const actions: ActionConfig[] = [
  {
    name: InventoryAdjustmentAction.Approve,
    isVisible: (inventoryAdjustment, permissions, isCurrentUserAssignee) =>
      isCurrentUserAssignee &&
      !!permissions[InventoryAdjustmentAction.Approve] &&
      ApproveActionVisibleStatusMap.includes(inventoryAdjustment.statusCode),
    hasConfirmationDialog: true,
    buttonProps: {
      variant: "filled",
      iconComponent: CheckIcon,
      className: styles.approve,
    },
    dialogButtonProps: {
      variant: "filled",
    },
  },
  {
    name: InventoryAdjustmentAction.SignOf,
    isVisible: (inventoryAdjustment, permissions, isCurrentUserAssignee) =>
      isCurrentUserAssignee &&
      !!permissions[InventoryAdjustmentAction.SignOf] &&
      SignOfActionVisibleStatusMap.includes(inventoryAdjustment.statusCode),
    hasConfirmationDialog: true,
    buttonProps: {
      variant: "filled",
      iconComponent: CheckIcon,
      className: styles.approve,
    },
    dialogButtonProps: {
      variant: "filled",
    },
  },
  {
    name: InventoryAdjustmentAction.Invalidate,
    isVisible: (inventoryAdjustment, permissions, isCurrentUserAssignee) =>
      isCurrentUserAssignee &&
      !!permissions[InventoryAdjustmentAction.Invalidate] &&
      InvalidateActionVisibleStatusMap.includes(inventoryAdjustment.statusCode),
    hasConfirmationDialog: true,
    buttonProps: {
      variant: "filled",
      iconComponent: CloseIcon,
      className: styles.invalidate,
    },
    dialogButtonProps: {
      variant: "filled",
      iconComponent: CheckIcon,
    },
  },
];
